import { getCore } from '../../../client/core/getCore';
import type { DynamicClient } from '../../../client/types';
import { getBuffer } from '../../../utils/getBuffer';
import type { SessionKeys } from '../sessionKeys.types';

export const getSessionKeys = (client: DynamicClient) => {
  const core = getCore(client);

  const encodedKeys = core.state.get().sessionKeys;

  if (!encodedKeys) {
    return undefined;
  }

  try {
    const decodedKeys: SessionKeys = JSON.parse(
      getBuffer().from(encodedKeys, 'base64').toString()
    );

    return decodedKeys;
  } catch (error) {
    core.logger.error('Error decoding session keys', error);
    return undefined;
  }
};
